import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-brand-cream border-t border-brand-sand py-12" data-id="element-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-51">
        <h3 className="text-2xl font-serif font-bold text-brand-charcoal mb-2" data-id="element-52">
          🏋️ PILATES 360™
        </h3>
        <p className="text-gray-600 mb-8" data-id="element-53">
          El sistema de planificación N°1 para profesores de Pilates argentinos.
        </p>

        <div className="flex flex-wrap justify-center gap-8 mb-12" data-id="element-54">
          <a href="#" className="flex items-center gap-2 text-brand-charcoal hover:text-brand-terracotta transition-colors" data-id="element-55">
            <Mail size={20} data-id="element-56" /> contacto@pilates360.com.ar
          </a>
          <a href="#" className="flex items-center gap-2 text-brand-charcoal hover:text-brand-terracotta transition-colors" data-id="element-57">
            <Instagram size={20} data-id="element-58" /> @pilates360.ar
          </a>
          <a href="#" className="flex items-center gap-2 text-brand-charcoal hover:text-brand-terracotta transition-colors" data-id="element-59">
            <Globe size={20} data-id="element-60" /> www.pilates360.ar
          </a>
        </div>

        <div className="text-sm text-gray-500" data-id="element-61">
          © PILATES 360™ 2025 — Todos los derechos reservados.
          <br data-id="element-62" />
          Prohibida la reproducción y redistribución sin autorización expresa.
        </div>
      </div>
    </footer>;
};